import e from "./index31.js";
import { handleBreakpoints as t } from "./index33.js";
import n from "./index34.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/style/style.js
function r(e, t, n = !0) {
	if (!t || typeof t != "string") return null;
	if (e && e.vars && n) {
		let n = `vars.${t}`.split(".").reduce((e, t) => e && e[t] ? e[t] : null, e);
		if (n != null) return n;
	}
	return t.split(".").reduce((e, t) => e && e[t] != null ? e[t] : null, e);
}
function i(e, t, n, i = n) {
	let a;
	return a = typeof e == "function" ? e(n) : Array.isArray(e) ? e[n] || i : r(e, n) || i, t && (a = t(a, i, e)), a;
}
function a(a) {
	let { prop: o, cssProperty: s = a.prop, themeKey: c, transform: l } = a, u = (e) => {
		if (e[o] == null) return null;
		let a = e[o], u = e.theme, d = r(u, c) || {};
		return t(e, a, (e) => {
			let t = i(d, l, e);
			return e === t && typeof e == "string" && (t = i(d, l, `${o}${e === "default" ? "" : n(e)}`, e)), s === !1 ? t : { [s]: t };
		});
	};
	return u.propTypes = process.env.NODE_ENV === "production" ? {} : { [o]: e }, u.filterProps = [o], u;
}
//#endregion
export { a as default, r as getPath, i as getStyleValue };

//# sourceMappingURL=index35.js.map